import { render } from "./ChartSquareBarIcon.vue?vue&type=template&id=c1b11d2e"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__